// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import Home from '@/views/home/Home';
import index from '@/views/index';

/**
 * 基础菜单
 */
// 商品管理
import Goods from '@/views/goods/Goods';
//未入库包裹
import upcoming from '@/views/parcel/upcoming';
//更改商品信息
import productInformation from '@/views/parcel/productInformation';
//已发货商品
import deliverDoods from '@/views/parcel/deliverDoods';
//已到货包裹
import arrival from '@/views/parcel/arrival';
//已入库包裹storage
import storage from '@/views/parcel/storage';
//历史包裹
import history from '@/views/parcel/history';
//包裹详情
import parcelDetail from '@/views/parcel/parcelDetail';
//待确认包裹/undetermined/undetermined
import undetermined from '@/views/undetermined/undetermined';
//批次详情batchDetail
import batchDetail from '@/views/undetermined/batchDetail';
//未匹配包裹/undetermined/unmatch
import unmatch from '@/views/undetermined/unmatch';
//未匹配包裹填写物品信息writeInformation
import writeInformation from '@/views/undetermined/writeInformation';
//未匹配包裹选择线路selectRoute
import selectRoute from '@/views/undetermined/selectRoute';
//未发货包裹
import unShipments from '@/views/undetermined/unShipments';
//申请退货salessSeturn/applyFor
import applyFor from '@/views/salessSeturn/applyFor';
//待退货await
import awaits from '@/views/salessSeturn/await';
//已退货
import accomplish from '@/views/salessSeturn/accomplish';
//提货管理extractGoods
import extractGoods from '@/views/extractGoods/extractGoods';
//提货管理详情pickUpdetails
import pickUpdetails from '@/views/extractGoods/details';
//我要派送订单列表
import want from '@/views/deliveryOrder/want';
//已派送的订单accomplish
import accomplishOrder from '@/views/deliveryOrder/accomplish';
//正在派送订单beBeing
import beBeing from '@/views/deliveryOrder/beBeing';
//高级账户
//查单inquire
import inquire from '@/views/SeniorAaccount/inquire';
//待派送管理
import delivery from '@/views/SeniorAaccount/delivery';
//提货管理
import pickUp from '@/views/SeniorAaccount/pickUp';
//预约上门
import visit from '@/views/visit/visit';
//航班查询
import flight from '@/views/flight/flight';
//航班批次查询
import batchDetails from '@/views/flight/batchDetails';
//物流
import logistics from '@/views/logistics/logistics';
// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
  mode: 'history',
  routes: [{
      path: '/logindirect',
      meta: {
        title: '登录',
        noCache: true
      },
      component: (resolve) => require(['@/views/login'], resolve),
      hidden: true
    }, {
      path: '/',
      name: '',
      component: index,
      redirect: '/SeniorAaccount/inquire',
      meta: {
        requireAuth: true
      },
      children: [{
          path: '/home/Home',
          name: '首页',
          component: Home,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/goods/Goods',
          name: '创建运单',
          component: resolve => require(['@/views/goods/Goods'], resolve),
          // component: Goods,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/rules/Rules',
          name: '运输细则',
          component: resolve => require(['@/views/rules/Rules'], resolve),
          // component: Goods,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/receptionaddress/Receptionaddress',
          name: '收货地址',
          component: resolve => require(['@/views/receptionaddress/ReceptionAddress'], resolve),
          // component: Goods,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/announcement/Announcement',
          name: '公告',
          component: resolve => require(['@/views/announcement/Announcement'], resolve),
          // component: Goods,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/parcel/allOrder',
          name: '全部包裹',
          component: resolve => require(['@/views/parcel/allOrder'], resolve),
          // component: upcoming,
          meta: {
            requireAuth: true
          },
        },
        {
          
          path: '/parcel/nonPayment',
          name: '未付款包裹',
          component: resolve => require(['@/views/parcel/nonPayment'], resolve),
          // component: upcoming,
          meta: {
            requireAuth: true
          },
        },
        {
          path: '/parcel/upcoming',
          name: '未入库包裹',
          component: resolve => require(['@/views/parcel/upcoming'], resolve),
          // component: upcoming,
          meta: {
            requireAuth: true
          },
        }, {
          path: '/parcel/deliverDoods',
          name: '已发货包裹',
          component: resolve => require(['@/views/parcel/deliverDoods'], resolve),

          // component: deliverDoods,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/parcel/arrival',
          name: '已到货包裹',
          // component:arrival,
          component: resolve => require(['@/views/parcel/arrival'], resolve),
          meta: {
            requireAuth: true
          }
        }, {
          path: '/parcel/storage',
          name: '已入库包裹',
          component: resolve => require(['@/views/parcel/storage'], resolve),
          // component: storage,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/parcel/history',
          name: '历史包裹',
          component: resolve => require(['@/views/parcel/history'], resolve),
          // component: history,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/parcel/parcelDetail',
          name: '包裹详情',
          component: resolve => require(['@/views/parcel/parcelDetail'], resolve),
          // component: parcelDetail,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/parcel/productInformation',
          name: '更改商品详情',
          component: resolve => require(['@/views/parcel/productInformation'], resolve),
          meta: {
            requireAuth: true
          }

        },
        {
          path: '/undetermined/undetermined',
          name: '待确认包裹',
          component: resolve => require(['@/views/undetermined/undetermined'], resolve),
          meta: {
            requireAuth: true
          }

        },
        {
          path: '/undetermined/batchDetail',
          name: '批次详情',
          component: resolve => require(['@/views/undetermined/batchDetail'], resolve),
          meta: {
            requireAuth: true
          }

        },
        {
          path: '/undetermined/unmatch',
          name: '未匹配包裹',
          component: resolve => require(['@/views/undetermined/unmatch'], resolve),
          meta: {
            requireAuth: true
          }

        },
        {
          path: '/undetermined/writeInformation',
          name: '未匹配包裹填写物品信息',
          component: resolve => require(['@/views/undetermined/writeInformation'], resolve),
          meta: {
            requireAuth: true
          }

        },
        {
          path: '/undetermined/selectRoute',
          name: '未匹配包裹填写物品信息',
          component: resolve => require(['@/views/undetermined/selectRoute'], resolve),
          meta: {
            requireAuth: true
          }

        },
        {
          path: '/undetermined/unShipments',
          name: '未发货包裹',
          meta: {
            requireAuth: true
          },
          component: resolve => require(['@/views/undetermined/unShipments'], resolve),

        },
        {
          path: '/salessSeturn/applyFor',
          name: '申请退货包裹',
          component: resolve => require(['@/views/salessSeturn/applyFor'], resolve),
          meta: {
            requireAuth: true
          }

        },
        {
          path: '/salessSeturn/await',
          name: '申请退货包裹',
          component: resolve => require(['@/views/salessSeturn/await'], resolve),
          meta: {
            requireAuth: true
          }

        },
        {
          path: '/salessSeturn/accomplish',
          name: '申请退货包裹',
          component: resolve => require(['@/views/salessSeturn/accomplish'], resolve),
          meta: {
            requireAuth: true
          }

        },
        {
          path: '/extractGoods/extractGoods',
          component: resolve => require(['@/views/extractGoods/extractGoods'], resolve),
          name: '提货管理',
          meta: {
            requireAuth: true
          }

        },
        {
          path: '/extractGoods/details',
          name: '提货管理详情',
          component: resolve => require(['@/views/extractGoods/details'], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/deliveryOrder/want',
          name: '我要派送订单列表',
          component: resolve => require(['@/views/deliveryOrder/want'], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/deliveryOrder/accomplish',
          name: '已派送订单列表',
          component: resolve => require(['@/views/deliveryOrder/accomplish'], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/deliveryOrder/beBeing',
          name: '正在派送订单列表',

          component: resolve => require(['@/views/deliveryOrder/beBeing'], resolve),
          meta: {
            requireAuth: true
          }
        },

        {
          path: '/SeniorAaccount/inquire',
          name: '查单管理',
          component: resolve => require(['@/views/SeniorAaccount/inquire'], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/SeniorAaccount/billingSystem',
          name: '账单系统',
          component: resolve => require(['@/views/SeniorAaccount/billingSystem'], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/SeniorAaccount/delivery',
          name: '查单管理',
          component: resolve => require(['@/views/SeniorAaccount/delivery'], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/SeniorAaccount/pickUp',
          name: '提货管理',
          component: resolve => require(['@/views/SeniorAaccount/pickUp'], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/visit/visit',
          name: '预约上门',
          component: resolve => require(['@/views/visit/visit'], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/userInfo/userInfo',
          name: '个人中心',
          component: resolve => require(['@/views/userInfo/userInfo'], resolve),
          meta: {
            requireAuth: true
          }
        },

        {
          path: '/userInfo/recharge',
          name: '账户充值心',
          component: resolve => require(['@/views/userInfo/recharge'], resolve),
        
        },
        {
          path: '/userInfo/address',
          name: '收件人管理',
          component: resolve => require(['@/views/userInfo/address'], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/userInfo/bill',
          name: '账单中心',
          component: resolve => require(['@/views/userInfo/bill'], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/userInfo/addAddress',
          name: '新增收货人地址',
          component: resolve => require(['@/views/userInfo/addAddress'], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/flight/flight',
          name: '进度查询',
          component: resolve => require(['@/views/flight/flight'], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/logistics/logistics',
          name: '物流',
          component: resolve => require(['@/views/logistics/logistics'], resolve),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/flight/batchDetails',
          name: '航班批次',
          component: resolve => require(['@/views/flight/batchDetails'], resolve),
          meta: {
            requireAuth: true
          }
        },

      ],
    },


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js